import React from 'react';
import classNames from 'classnames';
import IconHeart from 'components/icons/iconHeart';
import { colorGrayLight3, colorRed } from 'styles/layout/colors';
import useProductFavoriteV2 from 'data-hooks/useProductFavoriteV2';

const PDPFavoriteButton = () => {
  const { isFavorited, onFavClick } = useProductFavoriteV2();
  
  return (
    <button
      type="button"
      className={classNames(
        'w-9 h-9 rounded-full flex items-center justify-center',
        {
          'bg-red': isFavorited,
          'bg-gray-light9 hover:bg-gray-light8': !isFavorited,
        }
      )}
      onClick={onFavClick}
    >
      <IconHeart
        className={classNames('w-[0.875rem] ', {
          'animate-heartbeat': isFavorited,
        })}
        color={isFavorited ? colorRed : colorGrayLight3}
        fill={isFavorited ? 'white' : colorGrayLight3}
      />
    </button>
  );

};

export default PDPFavoriteButton;
